import { render, staticRenderFns } from "./ProfitAndLossNotAvailable.vue?vue&type=template&id=7c0bc346&scoped=true&"
import script from "./ProfitAndLossNotAvailable.vue?vue&type=script&lang=js&"
export * from "./ProfitAndLossNotAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0bc346",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
